export type ViewerOpenMode = 'popup' | 'fullPage';
export type GalleryViewMode = 'filmstrip' | 'grid';
export type ThumbSize = 'small' | 'medium' | 'large';

const OPEN_MODE_KEY = 'jarvis.viewer.openMode';
const GALLERY_VIEW_MODE_KEY = 'jarvis.viewer.galleryViewMode';
const THUMB_SIZE_KEY = 'jarvis.viewer.thumbSize';

export const DEFAULT_VIEWER_OPEN_MODE: ViewerOpenMode = 'popup';
export const DEFAULT_GALLERY_VIEW_MODE: GalleryViewMode = 'filmstrip';
export const DEFAULT_THUMB_SIZE: ThumbSize = 'medium';

const THUMB_SIZES: readonly ThumbSize[] = ['small', 'medium', 'large'];
const OPEN_MODES: readonly ViewerOpenMode[] = ['popup', 'fullPage'];
const GALLERY_VIEW_MODES: readonly GalleryViewMode[] = ['filmstrip', 'grid'];

function storageAvailable(): boolean {
  return typeof localStorage !== 'undefined';
}

function readEnum<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  if (!storageAvailable()) return fallback;
  try {
    const raw = localStorage.getItem(key);
    if (raw && allowed.includes(raw as T)) return raw as T;
  } catch {
    /* ignore */
  }
  return fallback;
}

function writeEnum<T extends string>(key: string, value: T): void {
  if (!storageAvailable()) return;
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export function readViewerOpenMode(): ViewerOpenMode {
  return readEnum(OPEN_MODE_KEY, OPEN_MODES, DEFAULT_VIEWER_OPEN_MODE);
}

export function writeViewerOpenMode(mode: ViewerOpenMode): void {
  writeEnum(OPEN_MODE_KEY, mode);
}

export function readGalleryViewMode(): GalleryViewMode {
  return readEnum(GALLERY_VIEW_MODE_KEY, GALLERY_VIEW_MODES, DEFAULT_GALLERY_VIEW_MODE);
}

export function writeGalleryViewMode(mode: GalleryViewMode): void {
  writeEnum(GALLERY_VIEW_MODE_KEY, mode);
}

export function readThumbSize(): ThumbSize {
  return readEnum(THUMB_SIZE_KEY, THUMB_SIZES, DEFAULT_THUMB_SIZE);
}

export function writeThumbSize(size: ThumbSize): void {
  writeEnum(THUMB_SIZE_KEY, size);
}
